import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { CommunicationService } from '@propertelligent/client-api';
import EmptyState from '../../../../newComponents/emptystate';
import CustomTooltip from '../../../common/CustomTooltip';
import { GetImages } from '../../../../utils/GetImages';
import Compose from './Compose';
import apiHelper from '../../../../utils/apiHelper';
import NameAvatarComponent from '../../../../newComponents/NameAvatar/NameAvatar';
import { TextCss } from '../../../GlobalCss/TextCss';
import { Colors } from '../../../GlobalCss/Colors';
import { EmailBodyIframe, getEmailDisplayContent } from './EmailBodyIframe';

const ShowEmail = ({ emailId, onGetEmailList, setEmailId }) => {
  const [emailMessage, setEmailMessage] = useState([])
  const [important, setImportant] = useState(false)
  const [replyId, setReplyId] = useState<String>()
  const [replytype, setReplyType] = useState<String>("")
  const [forwardBody, setForwardBody] = useState("");
  const scrollDown = useRef(null);

  useEffect(() => {
    if (replyId && scrollDown.current) {
      const observer = new MutationObserver(() => {
        scrollDown.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      });
      observer.observe(scrollDown.current, { childList: true, subtree: true });
      setTimeout(() => {
        scrollDown.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }, 200);

      return () => observer.disconnect();
    }
  }, [replyId, emailMessage]);


  useEffect(() => {
    if (emailMessage?.length) {
      setReplyId(null);
    }
  }, [emailId, emailMessage?.length]);
  const OnDeleteEmail = (id) => {
    if (emailId !== id) {
      apiHelper(CommunicationService.deleteApiGmailDeleteEmailMessage, { successMessage: "Delete Email", failureMessage: "Unable to delete email", showNotification: true }, id)
        .then((res) => {
          getEmailMessages()
          onGetEmailList()
        }).catch((error) => { });
    } else
      apiHelper(CommunicationService.deleteApiGmailDeleteEmailThread, { successMessage: "Delete Email", failureMessage: "Unable to delete email", showNotification: true }, emailId)
        .then((res) => {
          setEmailId(null)
          getEmailMessages()
          onGetEmailList()
        }).catch((error) => { })
  }
  const onForwardEmail = (item) => {
    setReplyId(item.id);
    setReplyType("forward");
    setForwardBody(item.body);
  };

  const OnMakeImportant = (isImportant, id) => {
    if (emailId !== id) {
      let da = isImportant ? false : true

      setImportant(da)
      apiHelper(CommunicationService.postApiGmailToggleMessageImportance, { showNotification: false }, id, da)
        .then((res) => {
          getEmailMessages()
          onGetEmailList()
        }).catch((error) => { })
    }
    let da = isImportant ? false : true

    setImportant(da)
    apiHelper(CommunicationService.postApiGmailToggleThreadImportance, { showNotification: false }, id, da)
      .then((res) => {
        getEmailMessages()
        onGetEmailList()
      }).catch((error) => { })
  }

  const getEmailMessages = () => {
    apiHelper(CommunicationService.getApiGmailEmailThread, { showNotification: false }, emailId)
      .then((res) => {
        const allresults: any = res?.data?.success;
        setEmailMessage(allresults.messages);
      }).catch((error) => { });
  }

  useEffect(() => {
    if (emailId) getEmailMessages();
  }, [emailId, important]);

  const data = [
    {
      id: 1,
      img: GetImages.EmailForward,
      name: "Forward",
      linkpath: undefined
    },
    {
      id: 2,
      img: GetImages.BlackDelete,
      name: "Delete",
      linkpath: undefined
    },
  ]


  return (
    <>
      <div className="composeContainer">
        {emailId == null ? (
          <EmptyState
            bodytext="Click on the chat from left to start the conversation"
            isButton={false}
            isBorder={false}
          />
        ) : (<>
          {emailMessage?.map((item, index) => (
            <div className="ShowEmailSection" key={item?.id ?? index}>
              <div className={
                emailMessage?.length - 1 === index
                  ? ` gap-4 ShowEmailSectionInner`
                  : ` gap-4 ShowEmailSectionInner BorderBottom`
              } >
                <div className="userIcon ">
                  <NameAvatarComponent
                    firstName={item.fromName.split(" ")?.length > 0 &&
                      item.fromName.split(" ")[0]}
                    lastName={item.fromName.split(" ")?.length > 1
                      ? item.fromName.split(" ")[1]
                      : ""}
                    heightWidth={40}
                    shape="square"
                    className={TextCss.heading_700_16}
                    color={Colors.blue.regular}
                    backgroundColor={Colors.blue.lighter}
                  />

                </div>
                <div className="email_Deatils_section">
                  <div className="email_details_header ">
                    <div className="email_sender_detials ">
                      <p className="sub_heading text-start">
                        {item?.fromName}
                      </p>
                      <p className="sub_text  grey_subtext1">
                        {item?.displayDate}
                      </p>
                    </div>
                    <div className="email_action ">
                      <CustomTooltip children={<img
                        src={
                          !item?.isImportant
                            ? GetImages.BlueStar
                            : GetImages.FilledBlueStar
                        }
                        onClick={() =>
                          OnMakeImportant(item?.isImportant, item.id)
                        }
                        className="iconstyle"
                        alt="Important"
                      />}
                        content={"Marked as important"} />

                      <img
                        src={GetImages.BlueReply}
                        onClick={() => {
                          setReplyId(item.id);
                          setReplyType("reply");
                        }}
                        className="iconstyle"
                        alt="Reply"
                      />

                      <Dropdown>
                        <Dropdown.Toggle
                          style={{ outline: "none" }}
                          variant="none"
                          // id="filterDropdown"
                          className="m-0 p-0"
                        >
                          <img
                            src={GetImages.BlueMore}
                            className="iconstyle"
                            alt="More"
                          />

                        </Dropdown.Toggle>
                        <Dropdown.Menu className="m-2">
                          {data?.map((it, index) => (
                            <>
                              <Dropdown.Item
                                key={it.id}
                                onClick={() =>
                                  it.id == 2
                                    ? OnDeleteEmail(item.id)
                                    : onForwardEmail(item)
                                }
                              >
                                <div className="text-decoration-none d-flex flex-row align-items-center text-dark gap-2">
                                  {it.img && (
                                    <img
                                      src={it.img}
                                      width={20}
                                      height={20}
                                      alt="Black Email Icon"
                                    />
                                  )}
                                  <p className="sub-text">{it.name}</p>
                                </div>
                              </Dropdown.Item>
                              {index !== data.length - 1 && (
                                <Dropdown.Divider />
                              )}
                            </>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <p className="normal_text grey_subtext1">{item?.subject}</p>
                  <EmailBodyIframe body={getEmailDisplayContent(item)} />
                </div>
              </div>
            </div>
          ))}

          {replyId && (
            <>
              {/* <div className="w-100 BorderTop mt-1 ShowEmailSection"> */}
              <div className="compose-box-fixed mt-3">
                <Compose
                  getEmailMessages={getEmailMessages}
                  emailId={emailId}
                  replyId={replyId}
                  setReplyId={setReplyId}
                  replytype={replytype}
                  forwardBody={forwardBody} compose={undefined} setcompose={undefined} />
                <div ref={scrollDown} />
              </div>
            </>
          )}
        </>
        )}
      </div>
    </>

  );
}
export default ShowEmail